import { BreadcrumbItem } from '@src/api/common/BreadcrumbTypes';
import { PageTitle } from '@src/api/common/PageTitleType';

const Breadcrumbs: Array<BreadcrumbItem> = [
    { title: 'Admin', isLink: false },
    { title: 'Theme', href: '/admin/theme' },
    {
        title: 'Theme',
        prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
    },
];

const Title: PageTitle = {
    title: 'Theme',
    prefixedAddEditLabel: { Add: 'Create New', Edit: 'Edit' },
};

export { Breadcrumbs, Title };